import classNames from 'classnames';

import Indexable from '../../types/DataStructure/Indexable';

import styles from './Spacer.module.css';

const indexedStyles: Indexable = styles;

type Spacings =
    | 'none'
    | 'xxsmall'
    | 'xsmall'
    | 'small'
    | 'medium'
    | 'large'
    | 'xlarge'
    | 'xxlarge';

type SpacerProps = {
    vertical?: Spacings;
    horizontal?: Spacings;
};

const Spacer = ({
    vertical = 'medium',
    horizontal = 'medium',
}: SpacerProps) => {
    const classes = classNames(styles.Root, {
        [indexedStyles[`${vertical}Height`]]: !!vertical,
        [indexedStyles[`${horizontal}Width`]]: !!horizontal,
    });

    return <span className={classes} />;
};

export default Spacer;
